import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@comps/ui/tooltip";
import { Dashboard } from "@dto/Dashboard";
import { DashboardRightType, FullRightAccess, hasGlobalRightAccess } from "@dto/Users";
import { updateStorageSelection } from "@utils/localStorage";
import { getWsButtonStyle, TW_ViewListItem, TW_ViewListItemIcon, TW_ViewListItemPrivateIcon, TW_ViewListItemSelected, TW_ViewListItemSharedIcon, TW_ViewListItemText, TW_ViewListItemTooltipContent, TW_ViewListItemTooltipText } from "@utils/twClasses";
import { People, Profile, RowVertical } from "iconsax-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useModelStore, useUserStore } from "src/store";
import DashboardMenuButton from "./DashboardMenuButton";

interface DashboardListItemProps {
  dashboard: Dashboard;
  onMobileClose?: () => void;
}

function DashboardListItem({ dashboard, onMobileClose }: DashboardListItemProps) {

  const workspace = useModelStore(state => state.selectedWorkspace);
  const selectDashboard = useModelStore(state => state.selectDashboard);
  const selectedDashboard = useModelStore(state => state.selectedDashboard);
  const navigate = useNavigate();
  const wsHoverColor = useModelStore(state => state.wsHoverColor);
  const wsColor = useModelStore(state => state.wsColor);
  const [isHover, setIsHover] = useState(false);
  const userRole = useModelStore(state => state.userRole);
  const user = useUserStore(state => state.user);
  const { t } = useTranslation();
  const onSelection = () => {
    if (!workspace?._key) {
      console.error("Workspace key is not set");
      return;
    }
    
    // Always close mobile sidebar when clicked
    if (onMobileClose) {
      onMobileClose();
    }
    
    if (selectedDashboard?._key !== dashboard._key) {
      selectDashboard(dashboard);
      updateStorageSelection(workspace?._key, null, null, dashboard._key);
      navigate(`/workspaces/${workspace._key}/dashboards/${dashboard._key}`);
    }
  }

  let style = isHover ? getWsButtonStyle(wsHoverColor, null, wsColor) : getWsButtonStyle('transparent', null, wsColor);

  const hasFullAccess = dashboard.ownerKey === user?._key || hasGlobalRightAccess(user, userRole, DashboardRightType, FullRightAccess, dashboard._key, true);
  return (
    <div className={`${selectedDashboard?._key === dashboard._key ? TW_ViewListItemSelected : TW_ViewListItem}`}
        onClick={onSelection}
        style={style} 
        onMouseEnter={() => setIsHover(true)} 
        onMouseLeave={() => setIsHover(false)}>
      <RowVertical className={TW_ViewListItemIcon} color="red" />
      <p className={TW_ViewListItemText}>{dashboard.name}</p>
      {hasFullAccess && <DashboardMenuButton dashboard={dashboard} showIcon={isHover}/>}
      {dashboard.shared &&
        <TooltipProvider>
          <Tooltip delayDuration={100}>
            <TooltipTrigger>
              <People className={TW_ViewListItemSharedIcon} />
            </TooltipTrigger>
            <TooltipContent className={TW_ViewListItemTooltipContent}>
              <div className={TW_ViewListItemTooltipText}>{t("dashboard.shared.icon.tooltip.1")}</div>
              <div className={TW_ViewListItemTooltipText}>{t("dashboard.shared.icon.tooltip.2")}</div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      }
      {!dashboard.shared &&
        <TooltipProvider>
          <Tooltip delayDuration={100}>
            <TooltipTrigger>
              <Profile className={TW_ViewListItemPrivateIcon} />
            </TooltipTrigger>
            <TooltipContent className={TW_ViewListItemTooltipContent}>
              <div className={TW_ViewListItemTooltipText}>{t("dashboard.private.icon.tooltip.1")}</div>
              <div className={TW_ViewListItemTooltipText}>{t("dashboard.private.icon.tooltip.2")}</div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      }
    </div>
  )
}

export default DashboardListItem;